import { Component, OnInit, ViewChild, ViewContainerRef, ComponentFactory, ComponentRef, ComponentFactoryResolver } from '@angular/core';
import { DxTreeViewComponent, DxContextMenuComponent } from 'devextreme-angular';
import { TranslateService } from '@ngx-translate/core';

import { AppService } from '@api';
import { SistemaService } from '@servicios/Sistema.Service';

import { AlertaEnum, DialogoEnum } from '@mensaje/Enumeraciones/MensajeEnumeraciones.enum';
import { MensajeService } from '@mensaje/Mensaje.Service';
import { RespuestaEstatusEnum } from '@enumeraciones/Enumeraciones.enum';

import { ColaboradorModalComponent } from '@contenido/AppContent/global/colaborador/colaborador.component';
import { Departamento } from '@modelo/catalogo/Departamento.model';
import { Puesto } from '@modelo/catalogo/Puesto.model';
import { Colaborador } from '@modelo/catalogo/Colaborador.model';
import { TipoDepartamento } from '@modelo/catalogo/TipoDepartamento.model';

import { ColaboradorFormComponent } from '@contenido/AppContent/configuracionrh/colaborador/colaboradorForm.component';

export class MenuItem {
  id: string = "";
  text: string = "";
}

@Component(
  {
    selector: 'organizacion',
    templateUrl: './organizacion.template.html',
    styleUrls: ['./organizacion.component.scss']
  })

export class OrganizacionComponent implements OnInit {
  @ViewChild(DxTreeViewComponent, { static: false }) treeView!: DxTreeViewComponent;
  @ViewChild(DxContextMenuComponent, { static: false }) contextMenu!: DxContextMenuComponent;
  menuItems: MenuItem[];
  expandir!: boolean;

  filtros: any;
  organigrama: any;
  selectedTreeItem: { itemData: any };
  selectedTreeParent: { parent: any };
  entidad: any
  public errorActivo!: boolean;

  tipo!: number;
  editable!: boolean;

  SelTipoDepartamento!: TipoDepartamento[];
  SelNivel!: any[];
  nivelobligatorio!: boolean
  SelAreaAcademica!: any[];

  SelDepartamentoFull!: any[];
  SelDepartamento!: any[];
  SelPuestoFull!: any[];
  SelPuesto!: any[];
  SelGrado: any[] = [];
  SelGradoFull: any[] = [];
  SelMaterias: any[] = [];

  treeDepartamento: any;

  idclick: any;
  agregarD: boolean = false;
  agregarP: boolean = false;
  mostrarMaterias: boolean = false;

  @ViewChild('colaborador') private colaborador!: ColaboradorModalComponent;
  consulta!: boolean;
  @ViewChild("containerFormulario", { read: ViewContainerRef }) containerFormulario!: ViewContainerRef;

  cache!: any;
  inter: any;
  inter2: any;

  parametroJefe!: any;
  parametroColaborador!: any;
  public abierto!: boolean;
  public animacion!: string;

  constructor(private appService: AppService, private mensajeService: MensajeService, public sistemaService: SistemaService, public translate: TranslateService, public _cfr: ComponentFactoryResolver) {
    this.menuItems = [
      { id: 'ADepartamento', text: 'Agregar departamento' },
      { id: 'EDepartamento', text: 'Eliminar departamento' },
      { id: 'APuesto', text: 'Agregar puesto' },
      { id: 'EPuesto', text: 'Eliminar puesto' },
      { id: 'AColaborador', text: 'Agregar colaborador' },
      { id: 'EColaborador', text: 'Quitar colaborador' },
    ];
    this.filtros = { puesto: true, colaborador: true };
    this.selectedTreeItem = { itemData: {} };
    this.selectedTreeParent = { parent: {} };
    this.entidad = {};
    this.expandir = false;
  }

  ngOnInit() {
    this.DatosIniciales();
  }

  DatosIniciales() {
    this.Buscar();
    this.setTipoDepartamento();
    this.setNivel();
    this.setAreaAcademica();
    this.setGrados();
    this.setDepartamento();
    this.setPuesto();

  }

  Buscar() {
    return new Promise((resolve) => {
      this.appService.Post("configuracionrh/organizacion/buscar", this.filtros).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
          this.organigrama = res.data;
          return resolve(true);
        }
      });

    });
  }

  setMateria(nivelid: number) {
    this.appService.Post("configuracionrh/organizacion/materia", {nivelid: nivelid}).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelMaterias = res.data;
      }
    });
  }

  ExpCont() {
    if (this.expandir) {
      this.treeView.instance.collapseAll();
      this.expandir = false;
    } else {
      this.treeView.instance.expandAll();
      this.expandir = true;
    }
  }

  ExpCont2() {
    this.inter2 = setInterval(() => {
      if (this.idclick) {
        this.treeView.instance.expandItem(this.idclick);
        this.treeView.instance.selectItem(this.idclick);
        clearInterval(this.inter2)
      } else {
        clearInterval(this.inter)
      }
    }, 2000);
  }

  selectItem(e: any) {
    this.selectedTreeItem = e;
    this.selectedTreeParent = e.node;
    let data = e.itemData;
    this.treeView.instance.unselectItem(this.idclick);
    if (data.expanded) {
      this.treeView.instance.collapseItem(data.id);
    } else {
      this.treeView.instance.expandItem(data.id);
    }
    var nextParent = e.node.parent;

    while (nextParent.itemData.tipo !== 1) {
      nextParent = nextParent.parent;
    }
    this.treeDepartamento = nextParent.itemData.obj;
    switch (data.tipo) {
      case 1:
        this.EditarDepartamento(data.obj);
        break;
      case 2:
        this.EditarPuesto(data.obj);
        break;
      case 3:
        this.EditarColaborador(data.obj);
        break;
    }
  }

  treeViewItemContextMenu(e: any) {
    this.selectedTreeItem = e;
    this.selectedTreeParent = e.node;
    let data = e.itemData;
    this.treeView.instance.unselectItem(this.idclick);

    const contextMenu = this.contextMenu.instance;
    contextMenu.option('items[0].visible', false);
    contextMenu.option('items[1].visible', false);
    contextMenu.option('items[2].visible', false);
    contextMenu.option('items[3].visible', false);
    contextMenu.option('items[4].visible', false);
    contextMenu.option('items[5].visible', false);

    switch (data.tipo) {
      case 1:
        contextMenu.option('items[0].visible', true);
        contextMenu.option('items[1].visible', true);
        contextMenu.option('items[2].visible', true);
        break;
      case 2:
        contextMenu.option('items[2].visible', true);
        contextMenu.option('items[3].visible', true);
        contextMenu.option('items[4].visible', true);
        break;
      case 3:
        contextMenu.option('items[5].visible', true);
        break;
    }

  }

  contextMenuItemClick(e: any) {
    switch (e.itemData.id) {
      case 'ADepartamento': {
        this.AgregarDepartamento();
        this.LoadPadresDep();
        break;
      }
      case 'EDepartamento': {
        this.QuitarDepartamento();
        break;
      }
      case 'APuesto': {
        this.AgregarPuesto();
        this.LoadPadresPue();
        break;
      }
      case 'EPuesto': {
        this.QuitarPuesto();
        break;
      }
      case 'AColaborador': {
        this.colaborador.seleccionMultiple = true;
        this.colaborador.Modal()
        break;
      }
      case 'EColaborador': {
        this.QuitarColaborador();
        break;
      }
    }
  }

  LoadPadresDep() {
    let data = this.selectedTreeItem.itemData;
    if (data) {
      this.idclick = data.id;
    }
    (this.entidad as Departamento).departamentosuperiorid = data.obj.departamentoid;
    this.RemoverIdDepartamento(0)
  }
  LoadPadresPue() {
    let data = this.selectedTreeItem.itemData;
    this.idclick = data.id;
    (this.entidad as Puesto).puestosuperiorid = data.obj.puestoid ? data.obj.puestoid : 0;
    (this.entidad as Puesto).departamentoid = data.obj.departamentoid;
    (this.entidad as Puesto).nivelid = data.obj.nivelid;
    if(this.entidad.nivelid && this.entidad.nivelid != 0) {
      this.mostrarMaterias = true;
      this.SelMaterias = [];
      this.setMateria(this.entidad.nivelid);
    }else{
      this.mostrarMaterias = false;
      this.SelMaterias = [];
    }
    this.RemoverIdPuesto(this.entidad.puestosuperiorid, data.obj.departamentoid);
  }


  AgregarDepartamento() {
    this.tipo = 1;
    this.editable = true;
    this.agregarD = false;
    this.nivelobligatorio = false;
    this.entidad = new Departamento();
  }
  EditarDepartamento(e: Departamento) {
    this.tipo = 1;
    this.editable = false;
    this.agregarD = true;
    this.AsociarNivel(e.tipodepartamentoid);
    this.RemoverIdDepartamento(e.departamentoid)
    this.entidad = new Departamento(e);
    let data = this.selectedTreeItem.itemData;
    this.idclick = data.id;
  }

  BuscarGrado(e: any) {
    if (e) {
      this.SelGrado = this.SelGradoFull.filter(x => x.nivelid == this.treeDepartamento.nivelid);
    } else {
      this.SelGrado = [];
      this.entidad.gradosid = [];
    }
  }

  AgregarPuesto() {
    this.tipo = 2;
    this.editable = true;
    this.agregarP = false;
    this.entidad = new Puesto();
  }
  EditarPuesto(e: Puesto) {
    this.tipo = 2;
    this.editable = false;
    this.agregarP = true;
    if(e.nivelid && e.nivelid != 0) {
      this.mostrarMaterias = true;
      this.SelMaterias = [];
      this.setMateria(e.nivelid);
    }else{
      this.mostrarMaterias = false;
      this.SelMaterias = [];
    }
    this.RemoverIdPuesto(e.puestoid, e.departamentoid, true);
    this.entidad = new Puesto(e);
    this.SelGrado = this.SelGradoFull.filter(x => x.nivelid == this.treeDepartamento.nivelid);
    if (e.gradosid != null) {
      this.entidad.gradosid = [];
      for (let valoremateria of e.gradosid.split(", ")) {
        this.entidad.gradosid.push(parseInt(valoremateria))
      }
    }

    if (e.materiasid != null) {
      this.entidad.materiasid = [];
      for (let materia of e.materiasid.split(", ")) {
        this.entidad.materiasid.push(parseInt(materia))
      }
    }

    let data = this.selectedTreeItem.itemData;
    this.idclick = data.id;
  }
  EditarColaborador(e: Puesto) {
    this.tipo = 3;
    this.editable = false;
    this.entidad = new Colaborador(e);
  }

  VerColaborador(id: number) {
    this.consulta = true;
    this.containerFormulario.clear();
    const factory: ComponentFactory<any> = this._cfr.resolveComponentFactory(ColaboradorFormComponent);
    var ref: ComponentRef<any> = this.containerFormulario.createComponent(factory);
    ref.instance.accion = { accionid: 2, accion: "Ver colaborador" };
    ref.instance.id = id;
    ref.instance.output.subscribe(() => {
      this.consulta = false;
      ref.destroy();
    });
  }

  Guardar() {
    switch (this.tipo) {
      case 1:
        this.GuardarDepartamento();
        break;
      case 2:
        this.GuardarPuesto();
        break;
      case 3:
        break;
    }
  }

  GuardarDepartamento() {
    this.errorActivo = true;

    if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripción");
    }
    if (!this.entidad.tipodepartamentoid) {
      //return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un tipo de departamento");
    }
    if (this.entidad.nivel) {
      if (!this.entidad.nivelid) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un nivel");
      }
    }
    if (this.entidad.areaacademica) {
      if (!this.entidad.areaacademicaid) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un área académica");
      }
    }

    let data = new Departamento(this.entidad);
    this.appService.Post("configuracionrh/departamento", data).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        this.Cancelar();
        this.setDepartamento();
        this.Buscar().then(x => {
          this.ExpCont2();
        });
      }
    })

  }

  QuitarDepartamento() {
    let data = this.selectedTreeItem.itemData.obj;
    let padre = this.selectedTreeParent.parent;
    let msj = "¿Estás seguro que quieres eliminar el departamento? <br> Esta acción no se podra deshacer.";
    let opciones = this.sistemaService.GetOpcionesEliminar();

        if ((this.selectedTreeItem.itemData.items as any[]).length) {
            var hijos = (this.selectedTreeItem.itemData.items as any[]).filter(x => x.tipo == 1);
            msj = 'El departamento "' + this.selectedTreeItem.itemData.text + '" contiene ' + hijos.length + ' departamentos dependientes. Al eliminarlo también se eliminarán los dependientes, así como sus puestos y asignaciones de colaboradores. <br>\n\
¿Deseas continuar con la eliminación del departamento?';
    }

        this.mensajeService.Dialogo(DialogoEnum.aviso, '', msj, opciones).then(res => {
            if (res == 1) {
                this.appService.Post("configuracionrh/departamento/eliminardepartamento",{"departamento":data, "hijos": hijos}).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        if(padre){
                            this.idclick = padre.itemData.id;
                        }
                        this.Buscar().then(x =>{
                            this.ExpCont2();
                        });
                    }
                })
            }
        })
    }

  GuardarPuesto() {
    this.errorActivo = true;

    if (!this.entidad.nombre || !this.entidad.nombre.trim()) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese una descripción");
    }
    if (!this.entidad.departamentoid) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese un departamento");
    }
    if (this.entidad.otropuesto && this.entidad.gradosid.length == 0) {
      return this.mensajeService.Alerta(AlertaEnum.Warning, "Seleccione un grado para el puesto");
    }

    let data = new Puesto(this.entidad);
    this.appService.Post("configuracionrh/puesto", data).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        this.Cancelar();
        this.setPuesto();
        this.Buscar().then(x => {
          this.ExpCont2();
        });
      }
    })

  }

  QuitarPuesto() {
    let data = this.selectedTreeItem.itemData.obj;
    let padre = this.selectedTreeParent.parent;
    let msj = "¿Estás seguro que quieres eliminar el puesto? <br> Esta acción no se podra deshacer.";
    let opciones = this.sistemaService.GetOpcionesEliminar();

        if ((this.selectedTreeItem.itemData.items as any[]).length) {
            var hijos = (this.selectedTreeItem.itemData.items as any[]).filter(x => x.tipo == 2 || x.tipo == 3);
            msj = 'El puesto "' + this.selectedTreeItem.itemData.text + '" contiene ' + hijos.length + ' puestos dependientes. Al eliminarlo también se eliminarán los dependientes, así como las asignaciones de colaboradores. <br>\n\
¿Deseas continuar con la eliminación del puesto?';
        }
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', msj, opciones).then(res => {
            if (res == 1) {
                this.appService.Post("configuracionrh/puesto/eliminarpuesto", {"puesto":data, "hijos": hijos}).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        if(padre){
                            this.idclick = padre.itemData.id;
                        }
                        this.Buscar().then(x =>{
                            this.ExpCont2();
                        });
                    }
                })
            }
        })
    }

  GuardarColaborador(colaborador: any) {
    let data: Puesto = this.selectedTreeItem.itemData.obj;
    this.appService.Post("configuracionrh/colaborador/puesto/organigrama/multiple", { "puestoid": data.puestoid, "listcolaborador": colaborador }).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
        this.colaborador.CerrarModal();
        let data2 = this.selectedTreeItem.itemData;
        this.idclick = data2.id;
        this.Buscar().then(x => {
          this.ExpCont2();
        });
      }
    })
  }

  QuitarColaborador() {
    let data = this.selectedTreeItem.itemData.obj;
    let padre = this.selectedTreeParent.parent;
    let opciones = this.sistemaService.GetOpcionesEliminar();
    opciones[0].Titulo = "Baja"
    this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres dar de baja el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
      if (res == 1) {
        this.appService.Put("configuracionrh/colaborador/puesto/" + data.puestoporcolaboradorid, { visibleorganigrama: false }).then(res => {
          if (res.status == RespuestaEstatusEnum.Success) {
            this.mensajeService.Alerta(AlertaEnum.Success, res.message);
            this.idclick = padre.itemData.id;
            this.Buscar().then(x => {
              this.ExpCont2();
            });
          }
        })
      }
    })
  }

  setTipoDepartamento() {
    this.appService.Post("configuracionrh/tipodepartamento/buscar", { activo: 1 }).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelTipoDepartamento = res.data
      }
    });
  }

  setNivel() {
    this.appService.Get("catalogo/nivel").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelNivel = res.data
      }
    });
  }

  setAreaAcademica() {
    this.appService.Get("catalogo/areaacademica").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelAreaAcademica = res.data
      }
    });
  }

  setGrados() {
    this.appService.Get("catalogo/grado").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelGradoFull = res.data;
      }
    })
  }

  setDepartamento() {
    this.appService.Post("configuracionrh/departamento/buscar", { activo: 1 }).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelDepartamentoFull = res.data
      }
    });
  }

  setPuesto() {
    this.appService.Post("configuracionrh/puesto/buscar", { activo: 1 }).then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.SelPuestoFull = res.data
      }
    });
  }

  AsociarNivel(tipodepartamentoid: number) {
    let tipodepartamento = this.SelTipoDepartamento.find(x => x.tipodepartamentoid == tipodepartamentoid);
    if (tipodepartamento && tipodepartamento.asociarnivel) {
      (this.entidad as Departamento).nivel = true;
      this.nivelobligatorio = true;
    } else {
      this.nivelobligatorio = false;
    }
  }

  RemoverIdDepartamento(departamentoid: number) {
    this.SelDepartamento = this.SelDepartamentoFull.filter(x => x.departamentoid != departamentoid);
  }
  RemoverIdPuesto(puestoid: number, departamentoid: number = 0, editar: boolean = false) {
    let puestoIn = [];
    let puestoOut = [];
    if (editar) {
      puestoIn = this.SelPuestoFull.filter(x => x.puestoid != puestoid && x.departamentoid == departamentoid);
    } else {
      puestoIn = this.SelPuestoFull.filter(x => x.departamentoid == departamentoid);
    }
    let departamento = this.SelDepartamentoFull.find(x => x.departamentoid == departamentoid);
    if (departamento?.departamentosuperiorid) {
      let puesto = this.SelPuestoFull.find(x => x.puestoid == puestoid);
      if(puesto.puestosuperiorid) {
        let puestosuperior = this.SelPuestoFull.find(x => x.puestoid == puesto.puestosuperiorid);
        if (puestosuperior?.departamentoid != puesto.departamentoid) {
          puestoOut = this.SelPuestoFull.filter(x => x.puestoid != puestoid && x.departamentoid == departamento.departamentosuperiorid);
        }
      }
    }
    this.SelPuesto = [...puestoIn, ...puestoOut];
    //this.entidad.puestosuperiorid = 0;
  }

  Cancelar() {
    this.selectedTreeItem = { itemData: {} };
    this.tipo = 0;
    this.editable = false;
    this.entidad = {};
    this.errorActivo = false;
    this.mostrarMaterias = false;
    this.SelMaterias = [];
  }

  //Lista de puestos con sus colaboradores asignados activos, si no tiene colaborador poner "Vacante"
  AsignacionColaboradores() {
    if (this.organigrama.length > 0) {
      this.appService.PostGetFile("configuracionrh/organizacion/exportarasignacion", {})
    } else {
      this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen ninguna registro en el organigrama")
    }
  }

  //Lista de colaboradores sin puesto asignado
  ValidarAsignacion() {
    if (this.organigrama.length > 0) {
      this.appService.PostGetFile("configuracionrh/organizacion/validacionasignacion", {})
    } else {
      this.mensajeService.Alerta(AlertaEnum.Warning, "No se tienen ninguna registro en el organigrama para validar")
    }
  }



  onDragChange(e: any) {
    if (e.fromComponent === e.toComponent) {
      const fromNode = this.findNode(this.treeView.instance, e.fromIndex);
      const toNode = this.findNode(this.treeView.instance, this.calculateToIndex(e));
      if (toNode !== null && this.isChildNode(fromNode, toNode) || !this.dragPosible(fromNode, toNode)) {
        e.cancel = true;
      }

      //Pase por cambios
      switch (fromNode.itemData.tipo) {
        case 1:
          if (toNode.itemData.tipo == 1) {
            if ((fromNode.itemData.obj as Departamento).departamentosuperiorid == (toNode.itemData.obj as Departamento).departamentoid) {
              e.cancel = true;
            }
          }
          break;
        case 2:
          if (toNode.itemData.tipo == 1) {
            if ((fromNode.itemData.obj as Puesto).departamentoid == (toNode.itemData.obj as Departamento).departamentoid && !(fromNode.itemData.obj as Puesto).puestosuperiorid) {
              e.cancel = true;
            }
          } else if (toNode.itemData.tipo == 2) {
            if ((fromNode.itemData.obj as Puesto).departamentoid == (toNode.itemData.obj as Departamento).departamentoid && (fromNode.itemData.obj as Puesto).puestosuperiorid == (toNode.itemData.obj as Puesto).puestoid) {
              e.cancel = true;
            }
          }
          break;
        case 3:
          if (fromNode.itemData.obj.puestoid == (toNode.itemData.obj as Puesto).puestoid) {
            e.cancel = true;
          }
          break;
        default:

          break;
      }
    }
  }

  onDragEnd(e: any) {
    if (e.fromComponent === e.toComponent && e.fromIndex === e.toIndex) {
      return;
    }

    const fromTreeView = this.treeView.instance;
    const toTreeView = this.treeView.instance;

    const fromNode = this.findNode(fromTreeView, e.fromIndex);
    const toNode = this.findNode(toTreeView, this.calculateToIndex(e));

    if (e.dropInsideItem && toNode !== null && !toNode.itemData.isDirectory) {
      return;
    }

    //this.cache = fromNode.itemData.id;

    this.MoverNodo(fromNode, toNode);

  }


  calculateToIndex(e: any) {
    if (e.fromComponent != e.toComponent || e.dropInsideItem) {
      return e.toIndex;
    }

    return e.fromIndex >= e.toIndex
      ? e.toIndex
      : e.toIndex + 1;
  }

  findNode(treeView: any, index: any) {
    const nodeElement = treeView.element().querySelectorAll('.dx-treeview-node')[index];
    if (nodeElement) {
      return this.findNodeById(treeView.getNodes(), nodeElement.getAttribute('data-item-id'));
    }
    return null;
  }

  findNodeById(nodes: any, id: any) {
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].itemData.id == id) {
        return nodes[i];
      }
      if (nodes[i].children) {
        const node: any = this.findNodeById(nodes[i].children, id);
        if (node != null) {
          return node;
        }
      }
    }
    return null;
  }

  isChildNode(parentNode: any, childNode: any) {
    let parent = childNode.parent;
    while (parent !== null) {
      if (parent.itemData.id === parentNode.itemData.id) {
        return true;
      }
      parent = parent.parent;
    }
    return false;
  }

  moveNode(fromNode: any, toNode: any, fromItems: any, toItems: any, isDropInsideItem: any) {
    const fromNodeContainingArray = this.getNodeContainingArray(fromNode, fromItems);
    const fromIndex = fromNodeContainingArray.findIndex((item: any) => item.id == fromNode.itemData.id);
    fromNodeContainingArray.splice(fromIndex, 1);

    if (isDropInsideItem) {
      toNode.itemData.items.splice(toNode.itemData.items.length, 0, fromNode.itemData);
    } else {
      const toNodeContainingArray = this.getNodeContainingArray(toNode, toItems);
      const toIndex = toNode === null
        ? toNodeContainingArray.length
        : toNodeContainingArray.findIndex((item: any) => item.id == toNode.itemData.id);
      toNodeContainingArray.splice(toIndex, 0, fromNode.itemData);

    }

  }

  getNodeContainingArray(node: any, rootArray: any) {
    return node === null || node.parent === null
      ? rootArray
      : node.parent.itemData.items;
  }

  getTopVisibleNode(component: any) {
    const treeViewElement = component.element();
    const treeViewTopPosition = treeViewElement.getBoundingClientRect().top;
    const nodes = treeViewElement.querySelectorAll('.dx-treeview-node');
    for (let i = 0; i < nodes.length; i++) {
      const nodeTopPosition = nodes[i].getBoundingClientRect().top;
      if (nodeTopPosition >= treeViewTopPosition) {
        return nodes[i];
      }
    }

    return null;
  }

  dragPosible(inicio: any, fin: any) {
    switch (fin.itemData.tipo) {
      case 1:
        return inicio.itemData.tipo == 1 || inicio.itemData.tipo == 2;
        break;
      case 2:
        return inicio.itemData.tipo == 2 || inicio.itemData.tipo == 3;
        break;
      case 3:
        return false;
        break;
      default:
        return false;
        break;
    }
  }

  MoverNodo(inicio: any, fin: any) {
    let opciones = this.sistemaService.GetOpcionesEliminar();
    opciones[0].Titulo = "Mover";

    let data: any;
    let destino: any;
    switch (inicio.itemData.tipo) {
      case 1:
        data = new Departamento(inicio.itemData.obj);
        if (fin.itemData.tipo == 1) {
          destino = new Departamento(fin.itemData.obj);
          (data as Departamento).departamentosuperiorid = (destino as Departamento).departamentoid;
        }
        this.entidad = data;
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres mover el departamento?', opciones).then(res => {
          if (res == 1) {
            this.GuardarDepartamento()
            this.idclick = fin.itemData.id;
          }
        })

        break;
      case 2:
        data = new Puesto(inicio.itemData.obj);
        if (fin.itemData.tipo == 1) {
          destino = new Departamento(fin.itemData.obj);
          (data as Puesto).departamentoid = (destino as Departamento).departamentoid;
          (data as Puesto).puestosuperiorid = 0;
        } else if (fin.itemData.tipo == 2) {
          destino = new Puesto(fin.itemData.obj);
          (data as Puesto).departamentoid = (destino as Puesto).departamentoid;
          (data as Puesto).puestosuperiorid = (destino as Puesto).puestoid;
        }
        this.entidad = data;
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres mover el puesto?', opciones).then(res => {
          if (res == 1) {
            this.GuardarPuesto()
            this.idclick = fin.itemData.id;
          }
        })


        break;
      case 3:
        data = new Colaborador(inicio.itemData.obj);
        if (fin.itemData.tipo == 2) {
          destino = new Puesto(fin.itemData.obj);
          this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres mover al colaborador? Se dará de baja su puesto actual', opciones).then(res => {
            if (res == 1) {
              this.appService.Put("configuracionrh/colaborador/puesto/mover/" + (destino as Puesto).puestoid, data).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                  this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                  this.colaborador.CerrarModal();
                  this.idclick = fin.itemData.id;
                  this.Buscar().then(x => {
                    this.ExpCont2();
                  });
                }
              })
            }
          })

        }
        break;
    }

  }

  async GetParametros() {
    await this.appService.Get("catalogo/parametro/PerfilIdJefeArea360").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.parametroJefe = res.data.parametro;
      }
    })
    await this.appService.Get("catalogo/parametro/PerfilIdColaboradores360").then(res => {
      if (res.status == RespuestaEstatusEnum.Success) {
        this.parametroColaborador = res.data.parametro;
      }
    })
  }

  Modal() {
    this.GetParametros().then(() => {
    this.animacion = this.sistemaService.animacionAbirModal;
    this.abierto = true;
    this.errorActivo = false;
    });
  }

  CerrarModal() {
    this.animacion = this.sistemaService.animacionCerrarModal;
    this.parametroColaborador = {};
    this.parametroJefe = {};
    setTimeout(() => {
      this.abierto = false;
    }, 310);
  }

  GuardarParametros() {
    this.errorActivo = true;

    if (!this.parametroJefe.valor) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese el id del perfil de jefe");
    }
    if (!this.parametroColaborador.valor) {
        return this.mensajeService.Alerta(AlertaEnum.Warning, "Ingrese el id del perfil de colaboradores");
    }
    let data = [this.parametroJefe, this.parametroColaborador];
    this.appService.Post("catalogo/parametro", data).then(res => {
        if (res.status == RespuestaEstatusEnum.Success) {
            this.mensajeService.Alerta(AlertaEnum.Success, res.message);
            this.CerrarModal();
        }
    })
}
}
